module.exports = __webpack_public_path__ + "img/ring_g_o_null_null@2x.6fd4ad6f.png";